import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ number = "919999999999", message = "Hello PMR Welfare Foundation, I'd like to know more." }) {
  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1FB855] flex items-center justify-center shadow-lg wa-pulse transition-colors"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
}
